<template>
  <article class="mobile-menu">
    <header>
      <i18n-t keypath="general.mobile_menu_description1" tag="h1">
        <template #smartphone>
          <span>{{ t('general.smartphone') }}</span>
        </template>
        <template #qr
          ><span>{{ t('general.qr') }}</span></template
        >
      </i18n-t>
    </header>

    <main>
      <p class="mobile-menu__contents">
        {{ t('general.mobile_menu_description2') }}<br />{{ t('general.mobile_menu_description3') }}
      </p>
      <div class="mobile-menu__image">
        <QrcodeVue :value="QRValue" :size="200" />
      </div>
      <div class="mobile-menu__image-description">
        <img src="@/assets/images/icon-view-menu.svg" alt="메뉴보기 아이콘" />
        {{ t('general.menu_view') }}
      </div>
    </main>

    <footer>
      <div class="mobile-menu__button">
        <BaseButton @button-click="handleConfirmClick">
          <template #icon>
            <img src="@/assets/images/icon-check-white.svg" alt="확인" />
          </template>
          {{ t('button.confirm') }}
        </BaseButton>
      </div>
    </footer>
  </article>
</template>

<script setup lang="ts">
  import BaseButton from '@/components/base/BaseButton.vue';
  import { useConfigStore } from '@/stores/config';
  import QrcodeVue from 'qrcode.vue';
  import { useI18n } from 'vue-i18n';

  const emits = defineEmits(['close']);

  const { t } = useI18n();
  const configStore = useConfigStore();

  const baseURL = import.meta.env.VITE_BASE_URL;
  const QRValue = `${baseURL}/home/${configStore.config.StoreID}/${configStore.config.SubStoreCode}`;

  /** 확인 버튼 클릭 */
  const handleConfirmClick = () => emits('close');
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .mobile-menu {
    display: grid;
    grid-template-rows: min-content 1fr min-content;
    align-items: center;
    height: 100%;
    padding: 2.9851vw;

    header {
      text-align: center;
      h1 {
        font-size: 3.7313vw;
        font-weight: bold;
        word-break: keep-all;
        @media (max-width: vars.$md) {
          font-size: 28px;
        }
        span {
          color: #d7201a;
        }
      }
    }

    main {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      gap: 1.4925vw;
      font-size: 2.0896vw;
      @media (max-width: vars.$md) {
        font-size: 18px;
        gap: 20px;
      }
      .mobile-menu__contents {
        color: #7e7e7e;
        text-align: center;
      }

      .mobile-menu__image-description {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.7463vw;
        width: auto;
        border: 0.0746vw dashed #707070;
        border-radius: 34px;
        padding: 0.7463vw 1.8657vw;
        text-align: center;
        font-size: 2.0896vw;
        @media (max-width: vars.$md) {
          height: 40px;
          padding: 8px 20px;
          font-size: 18px;
        }
      }
    }

    footer {
      display: flex;
      justify-content: center;
      .mobile-menu__button {
        width: 31.8657vw;
        @media (max-width: vars.$sm) {
          width: 100%;
        }
      }
    }
  }
</style>
